(function(){
  var toast=document.getElementById('toast');
  function say(m){if(!toast)return;toast.textContent=m;toast.classList.add('on');clearTimeout(say.h);say.h=setTimeout(function(){toast.classList.remove('on')},2200)}
  function count(){fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
    var el=document.getElementById('cart-count');if(el)el.textContent=c.item_count})}
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('form[action*="/cart/add"]'))return;
    e.preventDefault();
    var b=f.querySelector('[type=submit]');if(b)b.disabled=true;
    fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){say('Added to cart');count();if(b)b.disabled=false})
      .catch(function(){f.submit()});
  });
})();
